import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { TypeActiviteList } from '../components'

export function TypesActiviteListPage() {
  const { t } = useTranslation()

  return (
    <div>
      <EntityPageHeader
        title={t('administration.sections.activities.pageTitle', 'Gestion des Activités')}
        backTo="/administration"
        createTo="/administration/types-activite/create"
        createLabel={t('administration.sections.activities.createButton', 'Créer une activité')}
      />
      <TypeActiviteList />
    </div>
  )
}
